export { default as TagsByRestaurant } from './TagsByRestaurant'
